<template>
<div
  :class="[
    'ee-row',
    type === 'flex' ? 'ee-row--flex' : '',
    align !== 'top' ? `is-align-${align}` : '',
    justify !== 'start' ? `is-justify-${justify}` : ''
  ]"
  :style="style">
  <slot></slot>
</div>
</template>
<script>
  export default {
    compName: 'ee-row',
    props: {
      gutter: Number,
      type: String,
      justify: {
        type: String,
        default: 'start'
      },
      align: {
        type: String,
        default: 'top'
      }
    },
    computed: {
      style () {
        const ret = {}
        if (this.gutter > 0) {
          ret.marginRight = ret.marginLeft = `-${this.gutter / 2}px`
        }
        return ret
      }
    }
  }
</script>
<style src="../style/row.css"></style>



// WEBPACK FOOTER //
// src/packages/row/Row.vue?6913b82e